import Vue from 'vue';
import Swiper from 'swiper';

Vue.component('home-slider-component', {
    data() {
        return {
            swiper: null,
            swiperEl: null,
        };
    },

    mounted() {
        this.swiperEl = document.querySelector('.home__what__section-slider');
        this.initSwiper();
    },

    methods: {
        initSwiper() {
            this.swiper = new Swiper(this.swiperEl, {
                loop: true,
                spaceBetween: 30,
                slidesPerView: 'auto',
                slidesPerGroup: 1,
                // Responsive breakpoints
                breakpoints: {
                    1024: {
                        spaceBetween: 45,
                    },
                },
            });
        },

        nextSlide() {
            this.swiper.slideNext();
        },

        prevSlide() {
            this.swiper.slidePrev();
        },
    },
});
